import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { HashSet } from "../Utils/HashSet";
import { Link, LinkType } from "./Link";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";

//export interface LinkSetEntryJson {
//    link: LinkJson;
//}

//export interface LinkSetJson {
//    entries: LinkSetEntryJson[];
//}

export class LinkSet implements Iterable<Link>, ObjectSerializer {
	// SET of LINKS (no particular order)
	private _linkSet: HashSet<Link>;

	constructor() {
		this._linkSet = new HashSet<Link>();
	}

	public Add(link: Link): boolean {
		if (!link)
			return false;
		this._linkSet.Add(link);
		return true;
	}

	public First(): Link {
		return this._linkSet.First();
	}

	public AddOfType(linkType: LinkType): Link {
		var newLink: Link = new Link(linkType);
		this._linkSet.Add(newLink);
		return (newLink);
	}

	public BuildHistoricalLinks(oldLinks: LinkSet): number {
		this._linkSet.Clear();

		if (oldLinks.Count > 0) {
			var historicalLink: Link = null;

			this._linkSet.ForEach((oldLink) => {
				if (!oldLink.IsHistoricalLink())
					return;

				historicalLink = oldLink.BuildHistoricalLink();
				if (historicalLink == null)
					return;

				this._linkSet.Add(historicalLink);
			});
		}

		return (this._linkSet.Count);
	}

	public GetNonCoreLinks(): LinkSet {
		var links = new LinkSet();

		this._linkSet.ForEach((link) => {
			if (!link.HasLinkMembers)
				return;

			if (link.IsCoreLink() == true)
				return;

			links.Add(link);
		});

		return (links);
	}

	public Clear(): void {
		this._linkSet.ForEach((link) => {
			link.Clear();
		});

		this._linkSet.Clear();
	}

	public ClearByType(linkType: LinkType): void {
		var clearList = new Array<Link>();

		this._linkSet.ForEach((link) => {
			if (link.LinkType != linkType)
				return;
			clearList.push(link);
		});

		clearList.forEach((link) => {
			link.Clear();
			this._linkSet.Remove(link);
		});
	}

	public Contains(link: Link): boolean {
		return this._linkSet.Contains(link);
	}

	public get Count(): number {
		return (this._linkSet.Count);
	}

	public Clone(): LinkSet {
		//var linksJson: string = JSON.stringify(this);
		//return <LinkSet> JSON.parse(linksJson);
		return null;
	}

	public get IsEmpty() : boolean {
		return this._linkSet.Count <= 0;
	}

	public Remove(link: Link): boolean {
		if (!link)
			return false;
		this._linkSet.Remove(link);
		return true;
	}

	public RemoveAll(): void {
		this._linkSet.Clear();
	}

	public ForEach(callbackfn: (value: Link, index: number, array: Link[]) => void, thisArg?: any): void {
		this._linkSet.ForEach(callbackfn, thisArg);
	}

	public Some(callbackfn: (value: Link, index: number, array: Link[]) => boolean, thisArg?: any): boolean {
		return this._linkSet.Some(callbackfn, thisArg);
	}

	public Every(callbackfn: (value: Link, index: number, array: Link[]) => boolean, thisArg?: any): boolean {
		return this._linkSet.Every(callbackfn, thisArg);
    }

    //public static FromJson(json: LinkSetJson): LinkSet {
    //    var result = new LinkSet();

    //    if (json.entries !== undefined) {
    //        json.entries.forEach((entry) => {
    //            result.Add(Link.FromJson(entry.link));
    //        }, this);
    //    }

    //    return result;
    //}

	public static readonly ObjSer_ObjectName = "LinkSet_ObjectName";

	public Write(obj: any, context: any): void {
		let objName: string = "links";
		if (context[LinkSet.ObjSer_ObjectName] !== undefined)
			objName = context[LinkSet.ObjSer_ObjectName];

		obj[objName] = {};
		obj = obj[objName];

		obj.entries = [];
		ObjSerUtils.WriteObjSerCollection(obj.entries, this._linkSet, context);
	}

	public Read(obj: any, context: any): void {
		let objName: string = "links";
		if (context[LinkSet.ObjSer_ObjectName] !== undefined)
			objName = context[LinkSet.ObjSer_ObjectName];

		this._linkSet.Clear();

		if (!obj[objName])
			throw new Error();
		obj = obj[objName];

		if (obj.entries !== undefined)
			ObjSerUtils.ReadObjSerCollection(obj.entries, this._linkSet, (value: any) => new Link(), context);
	}
}
